import { gql } from "@apollo/client";

export const CAMPAIGNS = gql`
  query Campaigns(
    $where: CampaignWhereInput
    $like: CampaignWhereInput
    $take: Int
    $skip: Int
  ) {
    campaigns(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        name
        description
      }
      count
    }
  }
`;

export const CAMPAIGN = gql`
  query Campaign($where: CampaignWhereInput) {
    campaign(where: $where) {
      id
      name
      description
    }
  }
`;

const campaigns = { CAMPAIGNS, CAMPAIGN };

export default campaigns;
